import React from "react";

const PinterestIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5.45C5.673.45.95 5.173.95 11c0 4.47 2.78 8.287 6.705 9.824-.092-.834-.175-2.115.037-3.026.192-.823 1.237-5.244 1.237-5.244s-.317-.632-.317-1.566c0-1.467.85-2.562 1.91-2.562.9 0 1.334.675 1.334 1.485 0 .907-.576 2.26-.874 3.514-.248 1.05.527 1.907 1.563 1.907 1.875 0 3.316-1.977 3.316-4.83 0-2.527-1.815-4.292-4.407-4.292-3.002 0-4.764 2.25-4.764 4.578 0 .907.35 1.88.787 2.407.086.105.1.196.073.303-.08.333-.258 1.05-.293 1.196-.046.194-.153.234-.353.14-1.317-.612-2.14-2.538-2.14-4.086 0-3.328 2.416-6.384 6.97-6.384 3.66 0 6.503 2.608 6.503 6.093 0 3.636-2.292 6.563-5.474 6.563-1.07 0-2.074-.556-2.418-1.212 0 0-.53 2.014-.657 2.508-.238.916-.88 2.065-1.312 2.766.987.305 2.037.47 3.124.47 5.827 0 10.55-4.723 10.55-10.55C22.05 5.173 17.327.45 11.5.45"
        fill="#FFF"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default PinterestIcon;
